import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { TPreparedDayOffPublicated } from 'shared/types/dayoff.types';

const initialState: TPreparedDayOffPublicated[] = [];

export const dayOffSelectedSlice = createSlice({
  name: 'dayOffSelected',
  initialState,
  reducers: {
    add: (state, { payload }: PayloadAction<TPreparedDayOffPublicated>) => {
      state.push(payload);
      return state;
    },
    delete: (state, { payload }: PayloadAction<TPreparedDayOffPublicated>) => {
      const newState = state.filter(elem => elem.id !== payload.id);
      return newState;
    },
    set: (state, { payload }: PayloadAction<TPreparedDayOffPublicated[]>) => {
      return payload;
    },
  },
});

export const dayOffSelectedActions = dayOffSelectedSlice.actions;
export const dayOffSelectedReducer = dayOffSelectedSlice.reducer;
